import documentService from '../../api/document'
import {DOCUMENT} from '@/store/types'

export default {
  namespaced: true,
  state: {
    termsOfUse: null,
    privacyPolicy: null
  },
  getters: {
    termsOfUse(state) {
      return state.termsOfUse
    },
    privacyPolicy(state) {
      return state.privacyPolicy
    },
  },
  mutations: {
    [DOCUMENT.SET_TERMS](state, value) {
      state.termsOfUse = value
    },
    [DOCUMENT.SET_POLICY](state, value) {
      state.privacyPolicy = value
    }
  },
  actions: {
    getTermsOfUse: function ({dispatch, commit}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        documentService.getTermsOfUse().then((response) => {
          commit(DOCUMENT.SET_TERMS, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    getPrivacyPolicy: function ({dispatch, commit}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        documentService.getPrivacyPolicy().then((response) => {
          commit(DOCUMENT.SET_POLICY, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    }
  }
}
